import axios from './instance';

// Create a comment on a specific discussion
export const createComment = async (discussionId, commentData) => {
    try {
        const res = await axios.post(`http://localhost:8000/api/comments/${discussionId}`, commentData);
        return res.data;
    } catch (error) {
        const errorMessage = error.response
            ? error.response.data.message
            : error.message;
        console.error(`Error creating comment on discussion ID ${discussionId}: ${errorMessage}`);
        throw new Error(errorMessage);
    }
};


export const getComments = async (discussionId) => {
    try {
        const res = await axios.get(`http://localhost:8000/api/comments/${discussionId}`);
        return res.data;
    } catch (error) {
        console.error(`Error creating comment on discussion ID ${discussionId}:`, error);
        throw error;
    }
};

// Delete a specific comment by its ID on a discussion
export const deleteComment = async (id) => {
    try {
        const res = await axios.delete(`http://localhost:8000/api/comments/${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error deleting comment with ID ${id}`, error);
        throw error;
    }
};



// Update a comment on a discussion
export const updateComment = async (id, newComment) => {
    try {
        const res = await axios.patch(`http://localhost:8000/api/comments/${id}`, newComment);
        return res.data;
    } catch (error) {
        console.error(`Error updating comment with ID ${id}`, error);
        throw error;
    }
};
